// extracted by mini-css-extract-plugin
export default {"blue":"HW4_blue__3yheR","column":"HW4_column__lo5VN","testSpanError":"HW4_testSpanError__OnHrR"};